import { FC } from 'react';
import Box from '@/components/UI/box/Box';
import TitleReviewsAndLocation from '@/components/houses/_reusable/houseInfo/basicInfo/titleReviewsAndLocation/TitleReviewsAndLocation';
import HostProfile from '@/components/houses/_reusable/houseInfo/basicInfo/hostProfile/HostProfile';
import HouseInformation from '@/components/houses/_reusable/houseInfo/basicInfo/houseInformation/HouseInformation';
import MidTermFeatureBanner from './midTermFeatureBanner/MidTermFeatureBanner';
import noPrePayment from '@/public/images/product/midterm-banner/no-prepayment.svg';
import possibilityOfVisiting from '@/public/images/product/midterm-banner/possibility-of-visiting.svg';
import fullFacilities from '@/public/images/product/midterm-banner/full-facilities.svg';
import weeklyCleaning from '@/public/images/product/midterm-banner/hugeicons_cleaning-bucket.svg';
import { useMidTermQuery } from '@/components/houses/_hooks/useMidterm';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
const FeatureItems = [{
  icon: noPrePayment,
  title: 'بدون ودیعه'
}, {
  icon: weeklyCleaning,
  title: 'نظافت هفتگی'
}, {
  icon: possibilityOfVisiting,
  title: 'امکان بازدید'
}, {
  icon: fullFacilities,
  title: 'امکانات کامل'
}];
type Props = {
  props: ProductItemTypes;
};
const BasicInfo: FC<Props> = ({
  props
}) => {
  const {
    isMidTerm
  } = useMidTermQuery(props);
  return <Box id="possibilities" component={'section'} data-sentry-element="Box" data-sentry-component="BasicInfo" data-sentry-source-file="BasicInfo.tsx">
      {/* <MidtermInfo /> */}
      {isMidTerm ? <MidTermFeatureBanner features={FeatureItems} /> : <HostProfile props={props} />}
      <HouseInformation props={props} data-sentry-element="HouseInformation" data-sentry-source-file="BasicInfo.tsx" />
    </Box>;
};
export default BasicInfo;